// Tombol "Laporkan soal ini": anak memberi tahu pengelola bila kunci, soal, atau pembahasan
// terasa keliru. Laporan (beserta salinan soalnya) dikirim ke /api/laporan dan muncul di tab
// "Laporan soal" halaman admin. Tidak tersedia di versi demo (tanpa server).
import { $ } from '../core/dom.js';
import { esc } from '../core/format.js';
import { S, panggil } from './state.js';
import { MODE_DEMO } from './riwayat.js';
import { keyHTML, userHTML } from './jawaban.js';
import { sfx } from './sound.js';
import { ALASAN_LAPORAN, teksPolos } from '../../lib/analisis.js';

export const tombolLapor = () => (MODE_DEMO ? '' : '<button class="btn btn-sm btn-ghost lapor-btn" type="button" data-lapor>🚩 Laporkan soal</button>');

/** Salinan ringkas soal untuk laporan (teks polos, tanpa HTML). */
export function salinanSoal(q, mapel = S.mapel) {
  const pilihan = q.type === 'pg' ? q.options : q.type === 'mcma' ? q.options.map(o => o.t) : q.statements.map(s => s.t);
  return {
    id: q.id || null, mapel, sumber: q.sumber || '', topik: q.gen || String(q.topic || '').replace(/^bank:/, ''), judul: teksPolos(q.title, 80),
    tipe: q.type, teks: teksPolos(q.text, 1200), pilihan: pilihan.map(p => teksPolos(p, 300)), kunci: teksPolos(keyHTML(q).replace(/<\/li>/g, '; </li>'), 600),
    bacaan: q.bacaan ? { judul: q.bacaan.judul || '', teks: String(q.bacaan.teks || '').slice(0, 6000) } : null,
  };
}

/** Pasang tombol laporan di dalam `root` untuk soal `q` dan jawaban anak `sel`. */
export function pasangLapor(root, q, sel, { mapel } = {}) {
  root?.querySelectorAll('[data-lapor]').forEach(b => { b.onclick = () => bukaLapor(q, sel, { mapel, tombol: b }); });
}

function bukaLapor(q, sel, { mapel, tombol } = {}) {
  sfx.tap();
  const el = document.createElement('div');
  el.className = 'rya';
  el.setAttribute('role', 'dialog');
  el.setAttribute('aria-modal', 'true');
  el.setAttribute('aria-label', 'Laporkan soal');
  el.innerHTML = `<form class="card rya-kartu lapor-form" novalidate>
    <div class="rya-ikon" aria-hidden="true">🚩</div>
    <h3>Ada yang aneh dengan soal ini?</h3>
    <p class="muted">Terima kasih sudah teliti, ${panggil()}! Pilih yang paling sesuai.</p>
    <fieldset class="lapor-alasan"><legend class="sr-only">Alasan</legend>${Object.entries(ALASAN_LAPORAN).map(([k, t], i) => `<label><input type="radio" name="alasan" value="${k}"${i === 0 ? ' required' : ''}><span>${esc(t)}</span></label>`).join('')}</fieldset>
    <label class="lapor-catatan"><span>Ceritakan sedikit (boleh dikosongkan)</span><textarea name="catatan" rows="3" maxlength="300" placeholder="Contoh: menurutku jawabannya B karena …"></textarea></label>
    <p class="lapor-pesan" aria-live="polite"></p>
    <div class="rya-aksi"><button class="btn btn-go" type="submit">Kirim laporan</button><button class="btn btn-sm btn-ghost" type="button" data-batal>Batal</button></div>
  </form>`;
  document.body.append(el);
  const form = el.querySelector('form'), pesan = el.querySelector('.lapor-pesan'), tutup = () => el.remove();
  el.querySelector('[data-batal]').onclick = tutup;
  el.addEventListener('click', e => { if (e.target === el) tutup(); });
  el.addEventListener('keydown', e => { if (e.key === 'Escape') { e.stopPropagation(); tutup(); } });
  el.querySelector('input[name="alasan"]').focus();
  form.onsubmit = async e => {
    e.preventDefault();
    const alasan = form.alasan.value;
    if (!alasan) { pesan.textContent = 'Pilih salah satu alasan dulu, ya.'; return; }
    const kirim = form.querySelector('[type="submit"]');
    kirim.disabled = true; pesan.textContent = 'Mengirim…';
    try {
      const res = await fetch('/api/laporan', {
        method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ alasan, catatan: form.catatan.value, soal: salinanSoal(q, mapel), jawabanAnak: sel == null ? '' : teksPolos(userHTML(q, sel), 600) }),
      });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(d.pesan || 'Laporan belum terkirim.');
      form.innerHTML = `<div class="rya-ikon" aria-hidden="true">💌</div><h3>Laporan terkirim!</h3><p>Pengelola akan memeriksa soal ini. Terima kasih, ${panggil()}!</p><button class="btn btn-go" type="button" data-ok>Tutup</button>`;
      form.querySelector('[data-ok]').onclick = tutup;
      form.querySelector('[data-ok]').focus();
      if (tombol) { tombol.disabled = true; tombol.textContent = '✅ Sudah dilaporkan'; }
      sfx.ok?.();
    } catch (err) {
      kirim.disabled = false;
      pesan.textContent = navigator.onLine === false ? 'Sedang offline. Coba lagi saat terhubung internet.' : err.message;
    }
  };
}
